import { defineMessages } from 'react-intl';

export default defineMessages({
  sectionTitle: {
    id: 'fastCover.step10.sectionTitle',
    defaultMessage: 'Section 7 - Snow Sports Optional Cover',
  },
  yes: {
    id: 'fastCover.step10.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.step10.no',
    defaultMessage: 'No',
  },
  areYouClaimingForSnowSportsOptionalCover: {
    id: 'fastCover.step10.areYouClaimingForSnowSportsOptionalCover',
    defaultMessage: 'Are you claiming for Snow Sports Optional Cover?',
  },
  areYouClaimingForSnowSportEquipment: {
    id: 'fastCover.step10.areYouClaimingForSnowSportEquipment',
    defaultMessage: 'Are you claiming for Snow Sport Equipment?',
  },
  areYouClaimingForSnowEquipmentReplacementHire: {
    id: 'fastCover.step10.areYouClaimingForSnowEquipmentReplacementHire',
    defaultMessage: 'Are you claiming for Snow Equipment Replacement Hire?',
  },
  areYouClaimingForSnowPrepaidExpenses: {
    id: 'fastCover.step10.areYouClaimingForSnowPrepaidExpenses',
    defaultMessage: 'Are you claiming for Snow Prepaid Expenses?',
  },
  areYouClaimingForSnowResortClosure: {
    id: 'fastCover.step10.areYouClaimingForSnowResortClosure',
    defaultMessage: 'Are you claiming for Snow Resort Closure?',
  },
  toAssistYourClaim: {
    id: 'fastCover.step10.toAssistYourClaim',
    defaultMessage: 'To assist your claim:',
  },
  toAssistYourClaimDetail1: {
    id: 'fastCover.step10.toAssistYourClaim',
    defaultMessage: 'We may need the below documents, please provide those that are applicable.',
  },
  toAssistYourClaimDetail2: {
    id: 'fastCover.step10.toAssistYourClaim',
    defaultMessage: 'We may contact you to request further documentation',
  },
  document: {
    id: 'fastCover.step10.document',
    defaultMessage: 'Documents',
  },
  document1: {
    id: 'fastCover.step10.document1',
    defaultMessage: 'Police report or written report from a relevant authority or Travel Provider (Airline, hotel, Cruise Liner, Tour Company etc.).',
  },
  document2: {
    id: 'fastCover.step10.document2',
    defaultMessage: 'Damage or Repair report.',
  },
  document3: {
    id: 'fastCover.step10.document3',
    defaultMessage: 'Quote for repair or replacement.',
  },
  document4: {
    id: 'fastCover.step10.document4',
    defaultMessage: 'Purchase receipt or other Evidence of Ownership for each item claimed.',
  },
  document5: {
    id: 'fastCover.step10.document5',
    defaultMessage: 'For all losses or delays caused by your Transport Provider, a \'Property Irregularity Report\' from the Transport Provider.',
  },
  document6: {
    id: 'fastCover.step10.document6',
    defaultMessage: 'Written evidence from the Transport Provider confirming the days and hours your Snow Sport Equipment was delayed and the time that it was returned to you.',
  },
  document7: {
    id: 'fastCover.step10.document7',
    defaultMessage: 'Written confirm from medical practitioner of the nature of your injury or sickness.',
  },
  document8: {
    id: 'fastCover.step10.document8',
    defaultMessage: 'A coppy of your pre-book and repaid lift passes, snow sports equipment hire or lessons expenses.',
  },
  document9: {
    id: 'fastCover.step10.document9',
    defaultMessage: 'A copy of your itinerary.',
  },
  document10: {
    id: 'fastCover.step10.document10',
    defaultMessage: 'A copy of your pre-booked and re-paid travel itinerary.',
  },
  document11: {
    id: 'fastCover.step10.document11',
    defaultMessage: 'Written confirmation from the management of the resort stating the reason for the resort closure and how long the closure lasted.',
  },
  provideExplanation: {
    id: 'fastCover.step10.provideExplanation',
    defaultMessage: 'If you cannot provide any of the above documents, please provide an explanation why you are unable to.',
  },
  ifYourSnowSportEquipmentsWasLostStolenOrDamagedPleaseTellUs: {
    id: 'fastCover.step10.patientName',
    defaultMessage: 'If your Snow Sport Equipments was lost, stolen or damaged please tell us:',
  },
  howItHappened: {
    id: 'fastCover.step10.howItHappened',
    defaultMessage: '1. How it happened',
  },
  whereYouWereInRelationToTheItem: {
    id: 'fastCover.step10.whereYouWereInRelationToTheItem',
    defaultMessage: '2. Provide details of where you were in relation to the item at the time of loss, theft or damage',
  },
  anyThingAdditionalToAdd: {
    id: 'fastCover.step10.anyThingAdditionalToAdd',
    defaultMessage: '3. Anything additional to add?',
  },
  areYouClaimingFor: {
    id: 'fastCover.step10.areYouClaimingFor',
    defaultMessage: 'Are you claiming for',
  },
  loss: {
    id: 'fastCover.step10.loss',
    defaultMessage: 'Loss',
  },
  theft: {
    id: 'fastCover.step10.theft',
    defaultMessage: 'Theft',
  },
  damage: {
    id: 'fastCover.step10.damage',
    defaultMessage: 'Damage',
  },
  delay: {
    id: 'fastCover.step10.delay',
    defaultMessage: 'Delay',
  },
  whoDidYouReportThisTo: {
    id: 'fastCover.step10.whoDidYouReportThisTo',
    defaultMessage: 'Who did you report this to?',
  },
  police: {
    id: 'fastCover.step10.police',
    defaultMessage: 'Police',
  },
  hotelManagement: {
    id: 'fastCover.step10.hotelManagement',
    defaultMessage: 'Hotel Management',
  },
  cruiseShip: {
    id: 'fastCover.step10.cruiseShip',
    defaultMessage: 'Cruise Ship',
  },
  airline: {
    id: 'fastCover.step10.airline',
    defaultMessage: 'Airline',
  },
  tourGuide: {
    id: 'fastCover.step10.tourGuide',
    defaultMessage: 'Tour Guide',
  },
  other: {
    id: 'fastCover.step10.other',
    defaultMessage: 'Other (please describe)',
  },
  notReported: {
    id: 'fastCover.step10.notReported',
    defaultMessage: 'Not Reported',
  },
  otherDescription: {
    id: 'fastCover.step10.otherDescription',
    defaultMessage: 'Other description',
  },
  reportReferenceNumber: {
    id: 'fastCover.step10.reportReferenceNumber',
    defaultMessage: 'Report Reference Number',
  },
  descriptionOfItem: {
    id: 'fastCover.step10.descriptionOfItem',
    defaultMessage: 'Description of item',
  },
  datePurchased: {
    id: 'fastCover.step10.datePurchased',
    defaultMessage: 'Date purchased',
  },
  storeWhereItemWasPurchased: {
    id: 'fastCover.step10.storeWhereItemWasPurchased',
    defaultMessage: 'Store where item was purchased',
  },
  purchasePrice: {
    id: 'fastCover.step10.purchasePrice',
    defaultMessage: 'Purchase price',
  },
  currency: {
    id: 'fastCover.step10.currency',
    defaultMessage: 'Currency',
  },
  amountClaimed: {
    id: 'fastCover.step10.amountClaimed',
    defaultMessage: 'Amount claimed',
  },
  proofOfPurchaseAttached: {
    id: 'fastCover.step10.proofOfPurchaseAttached',
    defaultMessage: 'Proof of purchase attached',
  },
  addAdditionalItem: {
    id: 'fastCover.step10.addAdditionalItem',
    defaultMessage: 'Add Additional Item',
  },
  addItem: {
    id: 'fastCover.step10.addItem',
    defaultMessage: 'Items Claimed',
  },
  item: {
    id: 'fastCover.step10.item',
    defaultMessage: 'Item',
  },
  claimed: {
    id: 'fastCover.step10.claimed',
    defaultMessage: 'Claimed',
  },
  patientName: {
    id: 'fastCover.step10.patientName',
    defaultMessage: 'Patient\'s name',
  },
  relationshipToYou: {
    id: 'fastCover.step10.relationshipToYou',
    defaultMessage: 'Relationship to you',
  },
  patientDateOfBirth: {
    id: 'fastCover.step10.patientDateOfBirth',
    defaultMessage: 'Patients Date of Birth',
  },
  medicareNumber: {
    id: 'fastCover.step10.medicareNumber',
    defaultMessage: 'Medicare number',
  },
  whatIsYourInjuryOrIllness: {
    id: 'fastCover.step10.whatIsYourInjuryOrIllness',
    defaultMessage: 'What is your injury or illness?',
  },
  didThisOccurWhilstEngagingInSnowSportActivity: {
    id: 'fastCover.step10.didThisOccurWhilstEngagingInSnowSportActivity',
    defaultMessage: 'Did this occur whilst engaging in Snow Sport activity?',
  },
  wasTheInjuredIllTravellerAnInpatient: {
    id: 'fastCover.step10.wasTheInjuredIllTravellerAnInpatient',
    defaultMessage: 'Was the injured/ill traveller an inpatient?',
  },
  cancellationExpenses: {
    id: 'fastCover.step10.cancellationExpenses',
    defaultMessage: 'Pre-Paid Expenses Claimed',
  },
  addCancellationExpense: {
    id: 'fastCover.step10.addCancellationExpense',
    defaultMessage: 'Add Pre-Paid Expense',
  },
  cancellationExpenseTitle: {
    id: 'fastCover.step10.cancellationExpenseTitle',
    defaultMessage: 'Expense {index}',
  },
  cancellationExpensesDateCancelled: {
    id: 'fastCover.step10.cancellationExpenses.dateCancelled',
    defaultMessage: 'Date Pre-Paid',
  },
  cancellationExpensesCancelledBookingDescription: {
    id: 'fastCover.step10.cancellationExpenses.cancelledBookingDescription',
    defaultMessage: 'Description',
  },
  cancellationExpensesSupplier: {
    id: 'fastCover.step10.cancellationExpenses.supplier',
    defaultMessage: 'Supplier',
  },
  cancellationExpensesPrePaidAmount: {
    id: 'fastCover.step10.cancellationExpenses.cancellationExpensesPrePaidAmount',
    defaultMessage: 'Pre-Paid Amount',
  },
  cancellationExpensesRefundCompensationReceived: {
    id: 'fastCover.step10.cancellationExpenses.refundCompensationReceived',
    defaultMessage: 'Refund/Compensation Received',
  },
  cancellationExpensesCurrency: {
    id: 'fastCover.step10.cancellationExpenses.cancellationExpensesCurrency',
    defaultMessage: 'Currency',
  },
  textBoxEg: {
    id: 'fastCover.step10.cancellationExpenses.textBoxEg',
    defaultMessage: 'e.g: {value}',
  },
  additionalExpenses: {
    id: 'fastCover.step10.additionalExpenses',
    defaultMessage: 'Additional Expenses',
  },
  additionalExpenseTitle: {
    id: 'fastCover.step10.additionalExpenseTitle',
    defaultMessage: 'Additional Expense {index}',
  },
  addAdditionalExpense: {
    id: 'fastCover.step10.additionalExpenses.addAdditionalExpense',
    defaultMessage: 'Add Additional expenses',
  },
  additionalExpensesDateOfExpense: {
    id: 'fastCover.step10.additionalExpenses.dateOfExpense',
    defaultMessage: 'Date of Expense',
  },
  additionalExpensesDescription: {
    id: 'fastCover.step10.additionalExpenses.description',
    defaultMessage: 'Description',
  },
  additionalExpensesSupplier: {
    id: 'fastCover.step10.additionalExpenses.supplier',
    defaultMessage: 'Supplier',
  },
  additionalExpensesAmountPaid: {
    id: 'fastCover.step10.additionalExpenses.amountPaid',
    defaultMessage: 'Amount Paid',
  },
  additionalExpensesCurrency: {
    id: 'fastCover.step10.additionalExpenses.additionalExpensesCurrency',
    defaultMessage: 'Currency',
  },
  isRequired: {
    id: 'fastCover.step10.isRequired',
    defaultMessage: '\'{defaultMessage}\' is required',
  },
  expenseTableRequired: {
    id: 'fastCover.step10.expenseTableRequired',
    defaultMessage: 'Expense table fields are required fields.',
  },
  additionExpenseRequired: {
    id: 'fastCover.step10.additionExpenseRequired',
    defaultMessage: 'Additional Expense table fields are required fields.',
  },
  cancellationExpenseRequired: {
    id: 'fastCover.step10.cancellationExpenseRequired',
    defaultMessage: 'Cancellation expenses table fields are required fields.',
  },
  dateRefundWasReceived: {
    id: 'fastCover.step10.dateRefundWasReceived',
    defaultMessage: 'Date Refund was Received',
  },
  areThereAnyAdditionalExpensesToBeClaimed: {
    id: 'fastCover.step10.areThereAnyAdditionalExpensesToBeClaimed',
    defaultMessage: 'Are there any additional expenses to be claimed?',
  },
  itemWithIdx: {
    id: 'fastCover.step10.itemWithIdx',
    defaultMessage: 'Item {idx}',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step10/messages.js